/* Nūvo editorial cards — size selection + quick add-to-bag.
   Delegated listeners, so it covers cards rendered on any page (collection, search, featured, related). */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* --- size chip selection --- */
  function selectChip(chip) {
    var card = chip.closest('.nuvo-card');
    var group = chip.closest('.nuvo-card__sizes');
    if (!card || !group) return;
    group.querySelectorAll('.nuvo-card__size').forEach(function (c) { c.classList.remove('is-active'); });
    chip.classList.add('is-active');

    var state = chip.dataset.stockState || 'in';

    var priceEl = card.querySelector('.nuvo-card__price');
    if (priceEl && chip.dataset.price) {
      var nowEl = priceEl.querySelector('.nuvo-card__price-now');
      var wasEl = priceEl.querySelector('.nuvo-card__price-was');
      // Pre-order size shows its discounted price with the full price struck through.
      var isPreSale = state === 'pre' && chip.dataset.poPrice;
      var nowText = isPreSale ? chip.dataset.poPrice : chip.dataset.price;
      if (nowEl) nowEl.textContent = nowText; else priceEl.textContent = nowText;
      if (wasEl) {
        if (isPreSale) { wasEl.textContent = chip.dataset.price; wasEl.hidden = false; priceEl.classList.add('is-sale'); }
        else if (chip.dataset.compare) { wasEl.textContent = chip.dataset.compare; wasEl.hidden = false; priceEl.classList.add('is-sale'); }
        else { wasEl.hidden = true; priceEl.classList.remove('is-sale'); }
      }
    }

    // Stock badge reflects the selected size: In stock / Pre-order / Out of stock.
    var stock = card.querySelector('[data-card-stock]');
    if (stock) {
      stock.classList.remove('is-in', 'is-pre', 'is-out');
      stock.classList.add('is-' + state);
      stock.textContent = state === 'pre' ? 'Pre-order' : (state === 'out' ? 'Sold out' : 'In stock');
    }

    // "with code" promo badge: only for in-stock sizes (a pre-order size has its own price).
    var promo = card.querySelector('.nuvo-card__promo');
    if (promo) {
      if (state !== 'in') {
        promo.hidden = true;
      } else {
        promo.hidden = false;
        if (chip.dataset.price) {
          var pct = parseFloat(promo.getAttribute('data-promo-pct')) || 0;
          var promoPriceEl = promo.querySelector('.nuvo-card__promo-price');
          if (pct > 0 && promoPriceEl) {
            var m = chip.dataset.price.match(/([^\d]*)([\d.,]+)/);
            if (m) {
              var num = parseFloat(m[2].replace(/,/g, ''));
              if (!isNaN(num)) { promoPriceEl.textContent = m[1] + (num * (100 - pct) / 100).toFixed(2); }
            }
          }
        }
      }
    }

    var add = card.querySelector('.nuvo-card__quickadd');
    if (add) {
      add.dataset.variantId = chip.dataset.variantId;
      add.disabled = (state === 'out'); // can't add a sold-out size
    }
  }

  /* --- header cart count --- */
  function refreshCount() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = ('0' + cart.item_count).slice(-2);
        });
        return cart;
      })
      .catch(function () { return null; });
  }

  /* --- lightweight confirmation toast --- */
  var toastEl, toastTimer;
  function toast(message, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nuvo-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('nuvo-toast--error', !!isError);
    var link = isError ? '' : '<a href="' + root() + 'cart">View bag</a>';
    toastEl.innerHTML = '<span>' + message + '</span>' + link;
    requestAnimationFrame(function () { toastEl.classList.add('is-show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3800);
  }

  /* --- quick add --- */
  function quickAdd(btn) {
    var id = btn.dataset.variantId;
    if (!id || btn.disabled || btn.classList.contains('is-loading')) return;

    // Pre-order sizes go to the product page so the pre-order acknowledgement is seen.
    var card = btn.closest('.nuvo-card');
    var active = card && card.querySelector('.nuvo-card__size.is-active');
    if (active && active.dataset.stockState === 'pre') {
      var link = card.querySelector('.nuvo-card__name');
      if (link && link.getAttribute('href')) { window.location.href = link.getAttribute('href'); return; }
    }

    btn.classList.add('is-loading');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var data = {};
          try { data = JSON.parse(text); } catch (e) { /* non-JSON (e.g. throttle/HTML) */ }
          if (!res.ok) {
            throw new Error(
              data.description ||
              (res.status === 429 ? 'Busy right now — please try again in a moment.' : 'Sorry, that could not be added to your bag.')
            );
          }
          return data;
        });
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        return refreshCount();
      })
      .then(function () { toast('Added to bag'); })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        toast(err.message || 'Sold out', true);
        if (window.console) console.warn('Nūvo quick-add:', err);
      });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.nuvo-card__size');
    if (chip) { e.preventDefault(); selectChip(chip); return; }
    var add = e.target.closest('.nuvo-card__quickadd');
    if (add) { e.preventDefault(); quickAdd(add); }
  });
})();
